export default [
  "Ponta de cigarro",
  "Correio expresso",
  "Gelo",
  "Areia",
  "Fitoterapia",
  "Blocos de brincar",
  "Vassoura",
  "Primavera",
  "Cabeo de internet",
  "Lancheira",
  "Bolo",
  "Moedas",
  "Convite",
  "Amendoim",
  "Tubo de ensaio",
  "Cola",
  "Pelo de cachorro",
  "Diamante",
  "Suco",
  "Lanterna",
  "Labirinto",
  "vinho tinto",
  "Lâmpada de mesa",
  "Botão",
  "Saco",
  "Rato",
  "Fibra ótica",
  "Lâmpada",
  "Agulha e linha",
  "Rosa",
  "Ampulheta",
  "Madeira",
  "formigas",
  "Ventilador",
  "Calcinhas",
  "Enigma",
  "Bagagem",
  "Saco de soro intravenoso",
  "Camera de segurança",
  "Mancha de óleo",
  "guarda-chuva",
  "cartão",
  "Crânio",
  "Traje",
  "Histórias em quadrinhos",
  "pião",
  "pinça",
  "Chave",
  "Cabelo",
  "Violino",
  "copo",
  "Material de escritório",
  "Bicho de pelúcia",
  "crachá",
  "Pintura a óleo",
  "Legumes",
  "Capacete",
  "Batom",
  "Fichas de poquer",
  "Tempero",
  "Baralho",
  "Presente",
  "Salgadinhos",
  "Relógio de bolso",
  "Grampo",
  "Espelho",
  "Assinatura",
  "Folha",
  "Osso",
  "Repelente de mosquitos",
  "Flauta",
  "Anel",
  "Números",
  "Sangue",
  "Fax",
  "Cuecas",
  "Perfume",
  "Antiguidade",
  "Circuito elétrico",
  "Celular",
  "Meia",
  "Máscara",
  "Dados",
  "Bala",
  "Computador",
  "Bolsa de couro",
  "Plástico",
  "Folhas de chá",
  "Serragem",
  "Salto alto",
  "Fotografia",
  "Assistir",
  "Charuto",
  "Capa de chuva",
  "sapato de couro",
  "Certificado",
  "Câmera de vídeo",
  "Brincos",
  "unhas",
  "Fósforo",
  "Lenço de papel",
  "Uniforme",
  "Poeira",
  "Pino de segurança",
  "Jornal",
  "Lente",
  "Mouse",
  "bloqueio",
  "pãezinhos",
  "Pintura",
  "Luvas",
  "Drinque suave",
  "Plantar",
  "Sabonete",
  "Folheto",
  "Cardápio",
  "Chinelo de dedo",
  "Telefone",
  "Unha",
  "cortinas",
  "Carteira de identidade",
  "Recibo",
  "Alto falante",
  "Barata",
  "Carteira",
  "Papel do exame",
  "Bilhete de loteria",
  "Doce",
  "Revista",
  "Calendário",
  "Curativo",
  "Cabide",
  "Café",
  "Sino",
  "Pendrive",
  "Cinza de cigarro",
  "Marca",
  "Pó",
  "dentaduras",
  "carta confidencial",
  "Máscara cirúrgica",
  "Gato",
  "Ingredientes culinários",
  "Fantoche",
  "Carimbo de borracha",
  "Livro",
  "selo postal",
  "Peças de Mahjong",
  "Dicionário",
  "Aranha",
  "Joalheria",
  "Chapéu",
  "Nota",
  "Seringa",
  "Engrenagem",
  "Modelo",
  "Banknote",
  "Pão",
  "Inseto",
  "Enigma",
  "maçã",
  "grafite",
  "Giz",
  "Ar condicionado",
  "Jaqueta",
  "Fones de ouvido",
  "Máscara cosmética",
  "Oculos de sol",
  "Brinquedo",
  "Algodão",
  "Caderno",
  "Disquete",
  "Tinta",
  "Palito de dente",
  "Colar",
  "Envelope",
  "Diário",
  "Peruca",
  "documentos",
  "Mapa",
  "Sujeira",
  "Mosquito",
  "Caixa de ferramentas",
  "Cartão de visitas",
  "Gravata",
  "pano de limpeza",
  "Meias",
  "Tachinha",
  "Esponja",
  "Nota promissória",
  "Algemas",
  "Tatuagem",
  "Pulseira",
  "Tirar",
  "Prescrição",
  "Ferro",
  "Ovos",
  "Carta de amor",
  "fita cassete"
];
